import React, {Component} from 'react';
import { select, scaleLinear, drag, event, axisLeft, axisBottom } from 'd3';

import Plus from '../Icons/Plus';

import './Page.css';

class Page extends Component {
  constructor(props) {
      super(props);
      this.state ={}
  }

	componentDidMount() {
		this.updateCanvas();
		window.addEventListener('resize', this.updateCanvas);
		// update canvas before  printing
		const updateCanvas = this.updateCanvas;
		window.matchMedia('print').addListener(mql => mql.matches ? updateCanvas() : null);
		window.onbeforeprint = this.updateCanvas;
	}

	componentWillUnmount() {
	    window.removeEventListener('resize', this.updateCanvas);
	}

	componentDidUpdate() {
	  this.updateCanvas();
	}

	updateCanvas = () => {

		const { handleUpdatePlayers} = this.props;

		const svg = select(this.svg),
					width = this.page.clientWidth - 27,
					height = this.page.clientHeight -21;

		const xScale = scaleLinear().domain([0, 100]).range([30, width]),
		    	yScale = scaleLinear().domain([100, 0]).range([39, height-9]);

		const data = this.props.players.map(player => {
			player.x = xScale(player.xPosition);
			player.y = yScale(player.yPosition);
			player.r = player.size * 20;
			return player;
		})

		const axisX = axisBottom(xScale).tickSizeInner(-height+48);
		const axisY = axisLeft(yScale).tickSizeInner(-width+30);

		svg.select('.canvas-axis .x-axis').remove();
		svg.select('.canvas-axis')
			.append('g').attr('class','x-axis')
    	.attr('transform', 'translate(0,' + (height-9) + ')')
    		.call(axisX);

		svg.select('.canvas-axis .y-axis').remove();
		svg.select('.canvas-axis')
			.append('g').attr('class','y-axis')
    	.attr('transform', 'translate(30,0)')
    		.call(axisY);

		svg.select('.arrow.x')
			.attr('points', '21,0 ' + width + ',0 ' + (width+12) + ',9 '+ width + ',18 21,18')
			.attr('transform', 'translate(0,' + (height-18) + ')');
		svg.select('.arrow.y')
			.attr('points', '21,39 30,21 39,39 39,' + height + ' 21,' + height);

		const players = svg.selectAll('.player').data(data, d => d.id);

		var newPlayers = players.enter().append('g')
		    .attr('class', 'player')
		   .on('click', d => this.props.handleClickPlayer(d));

		newPlayers
		    .append('circle').attr('r', d => d.r)
		    .attr('cx', 0).attr('cy', 0)
		    .attr('style','filter:url(#dropshadow)');

		newPlayers
			.append('text')
				.text(d => d.id)
	     	.attr('text-anchor', 'middle')
	     	.attr('alignment-baseline', 'middle')
	 			.attr('fill', '#fff');

		players.exit().remove();

		svg.selectAll('.player')
			.attr('class', d => { return this.props.editorPlayer && d.id === this.props.editorPlayer.id ? 'player selected' : 'player' })
			.attr('transform', d => 'translate(' + d.x + ',' + d.y + ')')
			.select('circle')
				.attr('class', d => 'color' + d.color);

		svg.selectAll('.player')
				.select('text')
		    	.text(d => d.name)
		    	//.text(d => d.xPosition + ',' + d.yPosition)
		    	.attr('font-size', d => d.size * 6);

		svg.selectAll('.player')
		    .select('circle')
	    		.attr('r', d => d.r);

		svg.selectAll('.player')
			.call(drag()
        .on('start', dragstarted)
        .on('drag', dragged)
        .on('end', dragended));

		function dragstarted(d) {
		    select(this).classed('dragged', true);
		}

		function dragged(d) {
		    d.x = event.x;
				d.y = event.y;

				if (d.x < 0) d.x = 0;
				if (d.x > width) d.x = width;
				if (d.y < 0) d.y = 0;
				if (d.y > height) d.y = height;

				d.xPosition = Math.round(xScale.invert(d.x));
				d.yPosition = Math.round(yScale.invert(d.y));

		    select(this).raise()
		    	.attr('transform', d => 'translate(' + d.x + ',' + d.y + ')');
		}

		function dragended(d) {
		    select(this).classed('dragged', false);
		    const player = Object.assign({}, d);
		    player.x = xScale.invert(d.x);
		    player.y = yScale.invert(d.y);
		    handleUpdatePlayers(player);
		}

		function splitter(str, l){
		    var strs = [];
		    while(str.length > l){
		        var pos = str.substring(0, l).lastIndexOf(' ');
		        pos = pos <= 0 ? l : pos;
		        strs.push(str.substring(0, pos));
		        var i = str.indexOf(' ', pos)+1;
		        if(i < pos || i > pos+l)
		            i = pos;
		        str = str.substring(i);
		    }
		    strs.push(str);
		    return strs;
		}

		svg.selectAll('.player').each(function(d) {
			const thisPlayer = select(this),
						text = select(this).select('text').text(),
						lines = splitter(text,12);
			thisPlayer
				.select('text').text(null)
				.attr('y', (-0.2 +(-0.5 * lines.length)) + 'em')
				.selectAll('tspan')
				.data(lines).enter()
				.append('tspan')
					.attr('x', 0)
					.attr('dy', '1em')
					.text(d => d)
		})

	}


  render() {

		return (
			<div className='page' ref={page => this.page = page}>
				<button className='button-plus' onClick={this.props.handleClickPlus}><Plus/></button>
				<svg className='canvas' ref={svg => this.svg = svg}>
					<filter xmlns="http://www.w3.org/2000/svg" id="dropshadow" height="130%">
			      <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
			      <feOffset dx="2" dy="2" result="offsetblur"/>
			      <feComponentTransfer>
			        <feFuncA type="linear" slope="0.3"/>
			      </feComponentTransfer>
			      <feMerge>
			        <feMergeNode/>
			        <feMergeNode in="SourceGraphic"/>
			      </feMerge>
			    </filter>
					<filter id="dropshadow" height="130%">
					  <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
					  <feOffset dx="2" dy="2" result="offsetblur"/>
					  <feMerge>
					    <feMergeNode/>
					    <feMergeNode in="SourceGraphic"/>
					  </feMerge>
					</filter>
					<g className='canvas-grid' onClick={this.props.handleCloseEditor} >
						<rect className='background' x='0' y='0' width='100%' height='100%' />
					</g>
					<g className='canvas-axis'>
						<polygon className='arrow x'/>
						<polygon className='arrow y'/>
					</g>
      	</svg>
      	<textarea
      		className='label-axis'
	    		type='text'
	    		rows='6'
	        value={this.props.labelAxis}
	    		placeholder='label'
	    		onChange={this.props.handleChangelabelAxis}
  			/>
  			<input
      		className='labelX'
	    		type='text'
	        value={this.props.labelX}
	    		placeholder='label x as'
	    		onChange={this.props.handleChangelabelX}
  			/>
  			<textarea
      		className='labelY'
	    		type='text'
	    		rows='6'
	        value={this.props.labelY}
	    		placeholder='label y as'
	    		onChange={this.props.handleChangelabelY}
  			/>
		  </div>
		)
	}
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/Page.js